// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const PersonFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12 13a7 7 0 017 7l-.007.117A1 1 0 0118 21H6a1 1 0 01-1-1l.004-.24A7 7 0 0112 13zm0-10a4 4 0 110 8l-.2-.005A4 4 0 018 7l.005-.2A4 4 0 0112 3z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export const PersonFillOffset: IconOffset = {
    vertical: 10,
    horizontal: 18,
};

export default React.memo(PersonFill);
